import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { ST3TaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class ST3Repository extends RepositoryBase<ST3TaxTable> {
  protected readonly KEY_PATH = 'st3';
}
